import { useState } from "react";
import Select from "../../../../Components/UI/Select/Select";
import classes from "./BaseUrlSelect.module.css";

const BaseUrlSelect = () => {
  const [data, setData] = useState({
    baseSSOUrl: window.localStorage.getItem("baseSSOUrl") || null,
    baseERPUrl: window.localStorage.getItem("baseERPUrl") || null,
    showSelect: false,
  });
  const baseERPUrlOptions = [
    "https://servertest.lafarrerr.com:7072/",
    "https://servertest.lafarrerr.com:7074/",
    "https://serverent.lafarrerr.com:7072/",
    "https://serverent.lafarrerr.com:7074/",
    "https://servercmit.lafarrerr.com:7072/",
    "https://servertest.lafarrerr.com:6062/",
    "https://servertest.lafarrerr.com:9092/",
  ];
  const baseSSOUrlOptions = [
    "https://servertest.lafarrerr.com:7078/",
    "https://servertest.lafarrerr.com:9098/",
    "https://serverent.lafarrerr.com:7078/",
    "https://servercmit.lafarrerr.com:7078/",
    "https://servertest.lafarrerr.com:6068/",
  ];

  const changeHandler = (e) => {
    setData((ps) => ({ ...ps, [e.target.name]: e.target.value }));
    window.localStorage.setItem(e.target.name, e.target.value);
  };
  return (
    <>
      {data?.showSelect ? (
        <div className={`${classes.selectsContainer}`}>
          <div className={classes.selectContainer}>
            <Select
              label="BASE SSO URL"
              name="baseSSOUrl"
              onChange={changeHandler}
              options={baseSSOUrlOptions}
              skipFieldAccessCheck={true}
              value={data.baseSSOUrl}
            />
          </div>
          <div className={classes.selectContainer}>
            <Select
              label="BASE ERP URL"
              name="baseERPUrl"
              onChange={changeHandler}
              options={baseERPUrlOptions}
              skipFieldAccessCheck={true}
              value={data.baseERPUrl}
            />
          </div>
        </div>
      ) : null}

      <button
        className={classes.showHideBtn}
        onClick={() => setData((ps) => ({ ...ps, showSelect: !ps.showSelect }))}
      >
        Call It Magic
      </button>
    </>
  );
};

export default BaseUrlSelect;
